import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import {AppContainer} from 'react-hot-loader'
import {createStore, applyMiddleware, compose} from 'redux'
import immutable from 'immutable'
import axios from 'axios'

import {socketMiddleware, connectSocket} from './socket/socket.middleware'
import {localStorageMiddleware, loadTripFromSocket} from './socket/limited_socket.middleware'

import plannerApp from './index.reducer'
import App from './app.container'
import {loadInitialData} from './init/initialdata.action'
import {INITIAL_STATE} from './initial_state'

import {Router} from './services/router/router'
import {newRouterMiddleware} from './services/router/router.middleware'
import {routes} from './routes'

global.$ = global.$ || require('jquery')
global.jQuery = global.jQuery || require('jquery')

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

let socket = {
    middleware: socketMiddleware,
    connect: connectSocket
}

if (window.payload.isLunaTrip) {
    socket.middleware = localStorageMiddleware
    socket.connect = loadTripFromSocket
}

const middlewares = [
    socket.middleware,
    newRouterMiddleware('RESET'),
]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

let store = createStore(
    plannerApp, immutable.fromJS(INITIAL_STATE),
    composeEnhancers(applyMiddleware(...middlewares))
)

//socket.connect(window.collabUrl || ':1888', store)
socket.connect('https://collab.lunamoons.com/', store)

store.dispatch(loadInitialData(window.payload))

Router.initialize(store, routes)

const render = (Component) => {
    ReactDOM.render(
        <AppContainer>
            <Component/>
        </AppContainer>,
        window.document.getElementById('root')
    )
}

let WithProvider = () => (
    <Provider store={store}>
        <App/>
    </Provider>
)

render(WithProvider)

// Webpack Hot Module Replacement API
if (module.hot) {
    module.hot.accept('./app.container', () => {
        WithProvider = () => (
            <Provider store={store}>
                <App/>
            </Provider>
        )
        render(WithProvider)
    })
    module.hot.accept('./index.reducer', () => {
        store.replaceReducer(plannerApp)
    })
}
